import { render, staticRenderFns } from "./58.vue?vue&type=template&id=231b7f1a&scoped=true&"
var script = {}
import style0 from "./58.vue?vue&type=style&index=0&id=231b7f1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231b7f1a",
  null
  
)

export default component.exports